module.exports = __webpack_public_path__ + "site/img/paypay.bdff81fb.png";